import _ from 'lodash';
import { connect } from 'react-redux';
import createSelector from 'helpers/createSelector';
import moment from 'moment';
import { FeedList } from 'modules/feed';

export default connect(
  createSelector(
    (state) => ({
      model: _.get(state, 'search.feed'),
      query: _.get(state, 'router.location.query'),
      subjects: _.get(state, 'subject.entities'),
      mediaTypes: _.get(state, 'mediaType.mediaTypeById'),
      mediaTypeIds: _.get(state, 'mediaType.mediaTypeIds'),
    })
    ,
    (state) => {
      const { model, query, subjects, mediaTypes, mediaTypeIds } = state;
      const subjectId = _.get(query, 'subjectId');
      const subject = subjects[subjectId];
      const validMediaTypeIds = _.intersection(
        mediaTypeIds,
        _.keys(_.get(subject, 'queries')),
      );
      const mediaType = _.get(query, 'mediaType', validMediaTypeIds);
      const startDate = moment(_.get(query, 'startDate')).format('YYYY-MM-DD 00:00:00');
      const endDate = moment(_.get(query, 'endDate')).format('YYYY-MM-DD 23:59:59');
      let type = mediaType.length == 0 ? localStorage.defaultMediaType : mediaType;

      if (type) {
        localStorage.defaultMediaType = type;
      }

      let myQ = {
        subjectId: subjectId,
        mediaType: mediaType.length == 0 ? localStorage.defaultMediaType : mediaType,
        limit: 10,
        startDate: startDate,
        endDate: moment(new Date()).format('YYYY-MM-DD 23:59:59'),
      };
      return {
        model,
        query: {
          ...query,
          mediaType,
          startDate,
          endDate,
          limit: 10,
        }
      }
    }
  ),
  () => ({})
)(FeedList)



/** WEBPACK FOOTER **
 ** ./src/app/modules/search/components/SearchFeedListContainer.js
 **/